import React from "react";

const CardsSection = () => {
  const cards = [
    {
      id: 1,
      title: "Police News Plus - English",
      description:
        "Read daily online Police News from across India in English.",
      image: "../images/pnp_new_logo.jpg",
      link: "http://india.policenewsplus.com/",
      buttonText: "Read News",
      language: "English",
    },
    {
      id: 2,
      title: "Police News Plus - Tamil",
      description: "Read daily online Police News in Tamil Language.",
      image: "../images/pnp_new_logo.jpg",
      link: "http://tamil.policenewsplus.com/",
      buttonText: "Read News",
      language: "Tamil",
    },
    {
      id: 3,
      title: "Police News Plus - Telugu",
      description: "Read daily online Police News in Telugu Language.",
      image: "../images/pnp_new_logo.jpg",
      link: "http://telugu.policenewsplus.com/",
      buttonText: "Read News",
      language: "Telugu",
    },
    {
      id: 4,
      title: "Police News Plus - Kannada",
      description: "Read daily online Police News in Kannada Language.",
      image: "../images/pnp_new_logo.jpg",
      link: "http://kannada.policenewsplus.com/",
      buttonText: "Read News",
      language: "Kannada",
    },
    {
      id: 5,
      title: "Police News Plus - Malayalam",
      description: "Read daily online Police News in Malayalam Language.",
      image: "../images/pnp_new_logo.jpg",
      link: "#",
      buttonText: "Coming Soon",
      language: "Malayalam",
    },
    {
      id: 6,
      title: "Police News Plus - Hindi",
      description: "Read daily online Police News in Hindi Language.",
      image:"../images/pnp_new_logo.jpg",
      link: "#",
      buttonText: "Coming Soon",
      language: "Hindi",
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-full mb-6">
            <svg
              className="w-8 h-8 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9m0 0v12m0 0h6m-6 0h6"
              />
            </svg>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 uppercase">
            Police News Plus
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Multi-Language News Platform Delivering Comprehensive Police
            Coverage Across India
          </p>
          <div className="w-24 h-1 bg-blue-600 mx-auto mt-6 rounded-full"></div>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {cards.map((card) => (
            <div
              key={card.id}
              className="group bg-white rounded-2xl shadow-sm hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 hover:border-blue-200"
            >
              {/* Content */}
              <div className="p-6">
                {/* Language Badge */}
                <div className="flex items-center justify-between mb-4">
                  <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider bg-blue-50 px-3 py-1 rounded-full">
                    {card.language} Edition
                  </span>
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center group-hover:bg-blue-600 transition-colors duration-300">
                    <svg
                      className="w-4 h-4 text-blue-600 group-hover:text-white transition-colors duration-300"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                  </div>
                </div>

                {/* Publication Image */}
                <div className="mb-6 flex justify-center">
                  <div className="w-54 h-54 rounded-xl overflow-hidden transition-colors duration-300">
                    <img
                      src={card.image}
                      alt={`${card.title} Cover`}
                      className="w-full h-full object-contain"
                    />
                  </div>
                </div>

                {/* Title & Description */}
                <h3 className="text-xl font-bold text-gray-900 mb-3 text-center group-hover:text-blue-700 transition-colors duration-300">
                  {card.title}
                </h3>
                <p className="text-gray-600 text-center leading-relaxed mb-6">
                  {card.description}
                </p>

                {/* Stats Bar */}
                <div className="flex items-center justify-between mb-6 text-sm text-gray-500">
                  <div className="flex items-center">
                    <svg
                      className="w-4 h-4 mr-1 text-green-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Daily Updates
                  </div>
                  <div className="flex items-center">
                    <svg
                      className="w-4 h-4 mr-1 text-blue-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 2a8 8 0 100 16 8 8 0 000-16zM8 8a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1zm1 3a1 1 0 100 2h2a1 1 0 100-2H9z"
                        clipRule="evenodd"
                      />
                    </svg>
                    All India
                  </div>
                </div>

                {/* Action Button */}
                {/* <a
                  href={card.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group/btn w-full bg-[#e85e5e] hover:bg-[#0780af] text-white font-semibold py-4 px-6 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center justify-center"
                > */}

                {/* <a
                  href={card.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group/btn w-full bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white font-semibold py-4 px-6 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center justify-center"
                > */}

                {/* <a
                  href={card.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group/btn w-full bg-gradient-to-r from-red-600 via-red-500 to-red-600 hover:from-red-700 hover:via-red-600 hover:to-red-700 text-white font-semibold py-4 px-6 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center justify-center"
                > */}

                <a
                  href={card.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group/btn w-full bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-semibold py-4 px-6 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-red-500/50 hover:shadow-xl flex items-center justify-center"
                >
                  <span>{card.buttonText}</span>
                  <svg
                    className="w-5 h-5 ml-2 transform group-hover/btn:translate-x-1 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                    />
                  </svg>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Footer Note */}
        <div className="text-center mt-12">
          <p className="text-gray-500 text-sm">
            Trusted by millions of readers across India • Updated daily •
            Comprehensive coverage
          </p>
        </div>
      </div>
    </section>
  );
};

export default CardsSection;
